/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';
import { SystemVarsSalesRestService } from '@gh/builder-shared-data';

import { BuilderSetupSystemVarsRoutingModule } from './builder-setup-system-vars-routing.module';
import {
  AccountingAccountDialogComponent,
  SystemVarsAccountingExpenseSubtabComponent,
  SystemVarsAccountingJobsSubtabComponent,
  SystemVarsAccountingReceivablesSubtabComponent,
  SystemVarsAccountingTabComponent,
} from './components/system-vars-accounting-tab';
import { SystemVarsAccountsTwilioTabComponent } from './components/system-vars-accounts-tab/system-vars-accounts-twilio-subtab/system-vars-accounts-twilio-subtab.component';
import { SystemVarsAccountsTabComponent } from './components/system-vars-accounts-tab/system-vars-accounts-tab.component';
import { SystemVarsAccountsXeroTabComponent } from './components/system-vars-accounts-tab/system-vars-accounts-xero-subtab/system-vars-accounts-xero-subtab.component';
import { SystemVarsContactsTabComponent } from './components/system-vars-contacts-tab/system-vars-contacts-tab.component';
import { SystemVarsEstimatingCommonSubTabComponent } from './components/system-vars-estimating-tab/system-vars-estimating-common-subtab/system-vars-estimating-common-subtab.component';
import { SystemVarsEstimatingOrdersSubTabComponent } from './components/system-vars-estimating-tab/system-vars-estimating-orders-subtab/system-vars-estimating-orders-subtab.component';
import { SystemVarsEstimatingTabComponent } from './components/system-vars-estimating-tab/system-vars-estimating-tab.component';
import { SystemVarsFranchiseeTabComponent } from './components/system-vars-franchisee-tab/system-vars-franchisee-tab.component';
import { SystemVarsJobsCommonSettingsSubTabComponent } from './components/system-vars-jobs-tab/sys-vars-jobs-common-settings-subtab/sys-vars-jobs-common-settings-subtab.component';
import { SystemVarsJobsTabComponent } from './components/system-vars-jobs-tab/system-vars-jobs-tab.component';
import { SystemVarsLedgerTabComponent } from './components/system-vars-ledger-tab/system-vars-ledger-tab.component';
import { SystemVarsManagerTabComponent } from './components/system-vars-manager-tab/system-vars-manager-tab.component';
import { SystemVarsMasterZoneTabComponent } from './components/system-vars-master-zone-tab/system-vars-master-zone-tab.component';
import { SystemVarsPayablesTabComponent } from './components/system-vars-payables-tab/system-vars-payables-tab.component';
import { SystemVarsPrinterDetailsDialogComponent } from './components/system-vars-printer-list-tab/system-vars-printer-details-dialog/system-vars-printer-details-dialog.component';
import { SystemVarsPrinterListTabComponent } from './components/system-vars-printer-list-tab/system-vars-printer-list-tab.component';
import { SystemVarsReceivablesCommonSettingsSubtabComponent } from './components/system-vars-receivables-tab/system-vars-receivables-common-settings-subtab/system-vars-receivables-common-settings-subtab.component';
import { SystemVarsReceivablesScheduleSubtabComponent } from './components/system-vars-receivables-tab/system-vars-receivables-schedule-subtab/system-vars-receivables-schedule-subtab.component';
import { SystemVarsReceivablesTabComponent } from './components/system-vars-receivables-tab/system-vars-receivables-tab.component';
import { SystemVarsSalesTabComponent } from './components/system-vars-sales-tab/system-vars-sales-tab.component';
import { SystemVarsSupervisorTabComponent } from './components/system-vars-supervisor-tab/system-vars-supervisor-tab.component';
import { SystemVarsTabContainerComponent } from './components/system-vars-tab-container/system-vars-tab-container.component';
import {
  SystemVarsAccountingBusinessService,
  SystemVarsPrinterListTabBusinessService,
} from './resources';
import { AccMigrationBusinessService } from './resources/acc-migration-business.service';
import { SystemVarsAccountsTabBusinessService } from './resources/system-vars-accounts-tab-business.service';
import { SystemVarsContactsTabBusinessService } from './resources/system-vars-contacts-tab-business.service';
import { SystemVarsEstimatingBusinessService } from './resources/system-vars-estimating-business.service';
import { SystemVarsFranchiseeBusinessService } from './resources/system-vars-franchisee-business.service';
import { SystemVarsJobsBusinessService } from './resources/system-vars-jobs-business.service';
import { SystemVarsLedgerTabBusinessService } from './resources/system-vars-ledger-tab-business.service';
import { SystemVarsManagerTabBusinessService } from './resources/system-vars-manager-tab-business.service';
import { SystemVarsMasterZoneTabBusinessService } from './resources/system-vars-master-zone-tab-business.service';
import { SystemVarsPayablesTabBusinessService } from './resources/system-vars-payables-tab-business.service';
import { SystemVarsReceivablesTabBusinessService } from './resources/system-vars-receivables-tab-business.service';
import { SystemVarsSalesBusinessService } from './resources/system-vars-sales-business.service';
import { SystemVarsSupervisorTabBusinessService } from './resources/system-vars-supervisor-tab-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupSystemVarsRoutingModule,
  ],
  providers: [
    SystemVarsFranchiseeBusinessService,
    SystemVarsSalesBusinessService,
    SystemVarsContactsTabBusinessService,
    SystemVarsMasterZoneTabBusinessService,
    SystemVarsEstimatingBusinessService,
    SystemVarsAccountsTabBusinessService,
    SystemVarsSalesRestService,
    SystemVarsJobsBusinessService,
    SystemVarsPrinterListTabBusinessService,
    SystemVarsReceivablesTabBusinessService,
    SystemVarsManagerTabBusinessService,
    SystemVarsSupervisorTabBusinessService,
    SystemVarsPayablesTabBusinessService,
    SystemVarsLedgerTabBusinessService,
    SystemVarsAccountingBusinessService,
    AccMigrationBusinessService,
  ],
  declarations: [
    SystemVarsTabContainerComponent,
    SystemVarsMasterZoneTabComponent,
    SystemVarsSalesTabComponent,
    SystemVarsFranchiseeTabComponent,
    SystemVarsContactsTabComponent,
    SystemVarsEstimatingCommonSubTabComponent,
    SystemVarsAccountsTabComponent,
    SystemVarsAccountsTwilioTabComponent,
    SystemVarsAccountsXeroTabComponent,
    SystemVarsJobsTabComponent,
    SystemVarsJobsCommonSettingsSubTabComponent,
    SystemVarsEstimatingTabComponent,
    SystemVarsEstimatingOrdersSubTabComponent,
    SystemVarsPrinterListTabComponent,
    SystemVarsPrinterDetailsDialogComponent,
    SystemVarsSupervisorTabComponent,
    SystemVarsReceivablesTabComponent,
    SystemVarsReceivablesScheduleSubtabComponent,
    SystemVarsReceivablesCommonSettingsSubtabComponent,
    SystemVarsManagerTabComponent,
    SystemVarsPayablesTabComponent,
    SystemVarsLedgerTabComponent,
    SystemVarsAccountingTabComponent,
    SystemVarsAccountingReceivablesSubtabComponent,
    SystemVarsAccountingJobsSubtabComponent,
    SystemVarsAccountingExpenseSubtabComponent,
    AccountingAccountDialogComponent,
  ],
})
export class BuilderSetupSystemVarsModule {
}
